<template>
  <a v-if="visible" :href="trial ? learnmore_url : plansPage" @click="sendEvent" class="pro-badge" :data-testid="testid" target="_blank">
    <span>Pro</span>
  </a>
</template>

<script>
import track from '@/src/tracking';

export default {
  props: {
    utm_campaign: { type: String },
    utm_source: { type: String },
    utm_medium: { type: String },
    learnmore_url: { type: String },
    trial: { type: Boolean, default: false },
    visible: { type: Boolean, default: false }
  },
  computed: {
    plansPage: function() {
      return `/plans?utm_campaign=${this.utm_campaign}&utm_source=${this.utm_source}&utm_medium=${this.utm_medium}`;
    },
    testid: function() {
      return `pro-badge-${this.utm_medium}`;
    }
  },
  methods: {
    sendEvent: function () {
      const properties = {
        utm_campaign: this.utm_campaign,
        utm_source: this.utm_source,
        utm_medium: this.utm_medium
      }
      track('pro_badge_clicked', properties);
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../packs/application.scss';

.pro-badge {
	background: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
	color: $white;
	padding: 0rem 0.5rem;
	border-radius: 1rem;
	font-size: 0.9rem;
	margin: 0;
}

.pro-badge:hover {
	color: $white;
	text-decoration: none;
}
</style>
